import { render, staticRenderFns } from "./ViAlertsAndNotifications.vue?vue&type=template&id=0398f77b&scoped=true"
import script from "./ViAlertsAndNotifications.vue?vue&type=script&lang=js"
export * from "./ViAlertsAndNotifications.vue?vue&type=script&lang=js"
import style0 from "./ViAlertsAndNotifications.vue?vue&type=style&index=0&id=0398f77b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398f77b",
  null
  
)

export default component.exports